import {createReducer} from 'redux-create-reducer';
import shiroTrie from 'shiro-trie';
import {Keys, Actions} from '../constants';
import {standardLoadingReducerFactory} from './reducer-utils';
import {toImmutable} from "../action-creators/mutation-actions";

const accountTransform = (obj) => {
    const im = toImmutable(obj);

    if( obj.permissions) {
        const perms = shiroTrie.new();
        perms.add(obj.permissions);
        return im.set('permissions',perms);
    }
    return im;
};

export default createReducer(
    {},
    standardLoadingReducerFactory(
        Actions.GET_ACCOUNT,
        Keys.StoreSliceData.ACCOUNT,
        accountTransform
    )
);



// WEBPACK FOOTER //
// ./src/model/reducers/account-reducer.js